<template>
    <div class="autoShortlist">
        <el-dialog
            title="自动入围"
            :visible.sync="showAutoShortlist"
            width="500px"
            :before-close="closeDialog">
            <el-form :inline="true" ref="form" :model="form" :rules="rules" label-width="130px" size="mini" style="font-size: 14px;">
                <el-form-item label="入围方式" prop="wonType">
                    <el-radio-group v-model="form.wonType">
                        <el-radio label="1">按价格最低入围</el-radio>
                        <el-radio label="2" v-if="showScore">按综合分最高入围</el-radio>
                    </el-radio-group>
                </el-form-item>
                      <el-form-item label="入围策略" prop="wonStrategy">
                    <el-radio-group v-model="form.wonStrategy">
                        <el-radio label="1">入围</el-radio>
                        <el-radio label="2">淘汰</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="入围供应商数量" prop="candidateQty" v-if="form.wonStrategy==='1'">
                    <el-input-number v-model="form.candidateQty" :controls="false" :min="0"  placeholder="请输入入围供应商数量"></el-input-number>
                </el-form-item>
                <el-form-item label="兜底供应商数量" prop="subsidyQty" v-if="form.wonStrategy==='2'">
                    <el-input-number v-model="form.subsidyQty" :controls="false" :min="0"  placeholder="请输入兜底供应商数量"></el-input-number>
                </el-form-item>
                <el-form-item label="淘汰供应商数量" prop="weedOutQty" v-if="form.wonStrategy==='2'">
                    <el-input-number v-model="form.weedOutQty" :controls="false" :min="0"  placeholder="请输入淘汰供应商数量"></el-input-number>
                </el-form-item>
                <el-form-item label="标段名称" prop="extStr1s">
                    <el-input v-model="form.extStr1s" placeholder="请输入标段名称"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="closeDialog">取 消</el-button>
                <el-button type="primary" @click="confirm" :loading="loadding">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import { bidWonAuto, checkDtlDetailTiedFirst } from '../../../api/tenderDetails.js';
export default {
    name: 'auto-shortlist-dialog',
    data () {
        return {
            form: {
                wonType: '',
                wonStrategy: '',
                candidateQty: '',
                subsidyQty: '',
                weedOutQty: '',
                extStr1s: '',
            },
            rules: {
                wonType: [
                    { required: true, message: '请选择入围方式', trigger: 'change' }
                ],
                wonStrategy: [
                    { required: true, message: '请选择入围策略', trigger: 'change' }
                ],
                candidateQty: [
                    { required: true, message: '请输入入围供应商数量', trigger: ['blur', 'change'] }
                ],
                subsidyQty: [
                    { required: true, message: '请输入兜底供应商数量', trigger: ['blur', 'change'] }
                ],
                weedOutQty: [
                    { required: true, message: '请输入淘汰供应商数量', trigger: ['blur', 'change'] }
                ]
            },
            showScore: true,
            loadding: false
        };
    },
    props: {
        showAutoShortlist: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        tenderCode: {
            type: String,
            default: function() {
                return '';
            }
        },
        syntheticalScore: {
            type: String,
            default: function() {
                return '';
            }
        },
        tableData: {
            type: Array,
            default: function() {
                return [];
            }
        },
    },
    components: {},
    computed: {
        tableIds() {
            let ids = []
            // form.extStr1s 无值则去tableData所有id集合；form.extStr1s 有值但部分值不存在tableData中则返回空；form.extStr1s 所有值都存在tableData中则返回tableData过滤的id集合
            const formExtStr1s = this.form.extStr1s.replaceAll('，', ',').split(',').filter(item => !!item)
            const tableExtStr1s = this.tableData.map(item => item.extStr1)
            if (!this.form.extStr1s) {
                ids = this.tableData.map(item => { return { id: item.id } })
            } else if (formExtStr1s.some(item => !tableExtStr1s.includes(item))) {
                ids = []
            } else {
                ids = this.tableData.filter(item => formExtStr1s.includes(item.extStr1)).map(item => { return { id: item.id } })
            }
            return ids
        }
    },
    methods: {
        closeDialog() {
            this.$emit('update:showAutoShortlist', false);
        },
        getParams() {
            let extStr1s = [];
            if (this.form.extStr1s) {
                extStr1s = this.form.extStr1s.replaceAll('，', ',').split(',');
            }
            const params = {};
            Object.assign(params, this.form);
            params.extStr1s = extStr1s;
            params.tenderCode = this.tenderCode;
            return params;
        },
        /** 自动入围提醒 **/
        async confirmCheck () {
            if (this.form.extStr1s && !this.tableIds.length) {
                this.$message.warning('标段不存在!')
                return Promise.reject()
            }
            this.loadding = true
            const res = await checkDtlDetailTiedFirst(this.tableIds).catch(err => { this.loadding = false })
            this.loadding = false
            if (!res || +res.code !== 0) {
                return Promise.reject()
            }
            if (res.data) {
                return this.$confirm(res.data + '是否继续操作入围?', '自动入围提醒', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消'
                })
            } else {
                return Promise.resolve()
            }
        },
        confirm() {
            this.$refs['form'].validate((valid) => {
                if (valid) {
                    this.confirmCheck().then(() => { this.confirmReq() })
                }
            });
        },
        confirmReq() {
            this.loadding = true;
            bidWonAuto(this.getParams()).then(res => {
                if (res && res.code === '0') {
                    this.$message.success('自动入围成功');
                    this.closeDialog();
                    this.$emit('updateData');
                }
            }).finally(() => { this.loadding = false; });
        },
    },
    mounted() {
        if (this.syntheticalScore === 'N') {
            this.showScore = false;
        } else {
            this.showScore = true;
        }
    }
};
</script>
<style lang="less">
.autoShortlist{
    .el-form-item {
        margin-bottom: 10px;
    }
    .el-input-number{width: 160px;}
}
</style>